document.addEventListener("DOMContentLoaded", function () {
  console.log("Script loaded and waiting for input field...");

  const observer = new MutationObserver(function (mutationsList) {
    mutationsList.forEach((mutation) => {
      // Search for the specific input field
      const targetField = document.querySelector(
        'input[id="custom#what_product_or_packages_are_you_interested_in"]'
      );

      if (targetField) {
        console.log("Target input field detected:", targetField);

        // Locate the form element by traversing up the DOM
        const form = targetField.closest("form");
        if (form) {
          console.log("Form detected via input field:", form);

          // Stop observing since we've found the form
          observer.disconnect();

          // Add event listener for form submission
          form.addEventListener("submit", function (event) {
            console.log("Form submitted!");

            // Append the current URL to the input field value
            const currentValue = targetField.value || "";
            const currentURL = window.location.href;
            targetField.value = `${currentValue} - ${currentURL}`;

            console.log("Updated field value:", targetField.value);
          });
        } else {
          console.error("Form not found for the input field!");
        }
      }
    });
  });

  // Observe the body for changes
  observer.observe(document.body, { childList: true, subtree: true });
});
